import Form from 'react-bootstrap/Form'

import './marketingOptIn.scss'

export default function MarketingOptIn({
  checked,
  onChange,
  organizationName,
  optInMessage,
  disabled = false,
  id = 'marketing-email-opt-in',
}) {
  const customMessage = String(optInMessage || '').trim()
  const teamName = String(organizationName || '').trim()
  const label = customMessage
    ? customMessage
    : teamName
      ? `Send me emails from ${teamName} about upcoming events and offers.`
      : 'Send me emails about upcoming events and offers.'

  return (
    <Form.Check
      id={id}
      type="checkbox"
      className="marketing-opt-in"
      label={label}
      checked={Boolean(checked)}
      disabled={disabled}
      onChange={(event) => onChange(event.target.checked)}
    />
  )
}
